import { useState } from "react";
import { useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//general components
import MobileHeader from "../../../common/mobile-header/mobile-header";
import { BaseButton } from "../../../common/base-button/base-button";
import AutoCompleteComponent from "../../../common/base-select/autocomplete-component.js";

//import styles
import "./problem-sub-type.scss";

//import images and icons
import { ArrowForward } from "iconsax-react";

function ProblemSubType({ requestList, handleClick, typeId, defaulValue }) {
    //genetal
    const { t } = useTranslation();
    const { control } = useForm();

    const [inputValue, setInputValue] = useState("");
    const [selectedValue, setSelectedValue] = useState(defaulValue);
    const handleSubTypeChange = (value, name) => {
        setSelectedValue(value);
    };

    return (
        <>
            <MobileHeader title={t("support")} justifyContent="center" handleClick={() => handleClick("isType")} />
            <Grid
                className="problem-sub-type"
                container
                item
                xs={12}
                md={6}
                rowGap={{ xs: 4, md: 5 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
            >
                <Grid container item xs={12} alignItems="flex-start" display={{ xs: "none", sm: "flex" }}>
                    <Grid item xs={9}>
                        <span className="problem-sub-type__title">{t("problemSubTypeTitle")}</span>
                    </Grid>
                    <Grid
                        className="problem-sub-type__undo"
                        container
                        item
                        xs={3}
                        columnGap={1}
                        justifyContent="flex-end"
                        alignItems="center"
                        onClick={() => handleClick("isType")}
                    >
                        {t("back")} <ArrowForward size="24" color="var(--primary-color)" />
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={10} md={12}>
                    <AutoCompleteComponent
                        label={t("selectYourRequest")}
                        options={requestList?.support_type.find(item => item.id === typeId)?.childs}
                        name="subType"
                        defaultValue={selectedValue}
                        handleChange={handleSubTypeChange}
                        setInputValue={setInputValue}
                        control={control}
                        width="auto"
                    />
                </Grid>
                <Grid container item xs={6} md={4} alignItems="flex-end">
                    <BaseButton
                        text={t("submitRequest")}
                        color="primary"
                        size="large"
                        radius="radius-10"
                        handleClick={() => handleClick("isForm", typeId, selectedValue)}
                        disabled={!selectedValue}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default ProblemSubType;
